import * as R from 'ramda'
import * as React from 'react'
import PropTypes from 'prop-types'

import * as Emotion from '@emotion/core'
import * as Common from '@rushplay/common'
import * as I18n from '@rushplay/i18n'
import styled from '@emotion/styled'

import * as Icons from '../components/icons.js'
import { H3 } from '../components/common/headings'

import { GameQuery } from './game-query'
import { GameTile } from './game-tile'

const GameTileWrapper = styled.div`
  width: 100%;
  max-width: 200px;
  flex-shrink: 0;

  ${props => {
    return Emotion.css`
      /* Writing media query by hand as we can’t run functions inside "css" */
      @media (min-width: ${props.theme.breakpoints.md}) {
        width: auto;
        flex-shrink: initial;
      }
    `
  }}
`

const Grid = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: repeat(6, minmax(170px, 1fr));
  grid-gap: 15px;

  ${props => {
    return Emotion.css`
        /* Writing media query by hand as we can’t run functions inside "css" */
        @media (min-width: ${props.theme.breakpoints.sm}) {
          grid-template-columns: repeat(auto-fill, minmax(170px, 1fr))
        }
      `
  }}
`

export function CasinoRow(props) {
  const i18n = I18n.useI18n()
  return (
    <GameQuery
      name={props.section.name}
      params={R.assoc('limit', 6, props.section.params)}
      key={props.section.name}
    >
      {({ ids }) =>
        !R.isEmpty(ids) && (
          <Common.Box pb={2}>
            {props.tag && (
              <Common.Box
                as={Common.Link}
                display="flex"
                flexDirection="row"
                alignItems="center"
                pb="0"
                to={`/casino/${props.tag}`}
              >
                <H3
                  color="simpleorange"
                  style={{
                    fontSize: '14px',
                    fontWeight: 600,
                    textTransform: 'uppercase',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                    letterSpacing: '0.75px',
                  }}
                >
                  {i18n.translate(`casino.category.${props.tag}`)}
                </H3>
                <Common.Box mb="3px" pl={0} color="simpleorange">
                  <Icons.ArrowEast size="20px" />
                </Common.Box>
              </Common.Box>
            )}
            <Common.ScrollableRow>
              <Grid>
                {ids.map((id, index) => (
                  <GameTileWrapper key={id || `fake-${index}`}>
                    <GameTile id={id} color={props.color} />
                  </GameTileWrapper>
                ))}
              </Grid>
            </Common.ScrollableRow>
          </Common.Box>
        )
      }
    </GameQuery>
  )
}

CasinoRow.propTypes = {
  color: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  section: PropTypes.object.isRequired,
  tag: PropTypes.string.isRequired,
}
